import { render, staticRenderFns } from "./LibraryBlock.vue?vue&type=template&id=e5b17672&"
import script from "./LibraryBlock.vue?vue&type=script&lang=ts&"
export * from "./LibraryBlock.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports